import { createSchemaField } from '@formily/react';
import { componentMap } from '@/form/component-map';
export const SchemaField = createSchemaField({
    components: componentMap,
});
